import React, { Fragment } from "react";
import { Routes, Route, Navigate } from "react-router-dom"

import './assets/scss/themes.scss';
import NonAuthLayout from "./Layouts/NonAuthLayout";
import VerticalLayout from "./Layouts/index";

import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LoginScreen from "./screens/LoginScreen";
import PasswordForgotScreen from "./screens/PasswordForgotScreen";
import PasswordResetScreen from "./screens/PasswordResetScreen";
import UserProfileOtpView from "./screens/UserProfileOtpView";
import LogoutScreen from "./screens/LogoutScreen";
import DashboardScreen from "./screens/DashboardScreen";
import KanbanScreen from "./screens/KanbanScreen";
import NotificationSearchScreen from "./screens/NotificationSearchScreen";
import EmailSearchScreen from "./screens/EmailSearchScreen";
import NotFoundScreen from "./screens/NotFoundScreen";
import NotAuthorized from "./screens/NotAuthorized";
import InvalidCompany from "./screens/InvalidCompany";

import UserSearchScreen from "./screens/UserSearchScreen";
import UserEditScreen from "./screens/UserEditScreen";
import UserProfileScreen from "./screens/UserProfileScreen";

import CompanySearchScreen from "./screens/CompanySearchScreen";
import CompanyEditScreen from "./screens/CompanyEditScreen";

import RoleSearchScreen from "./screens/RoleSearchScreen";
import RoleEditScreen from "./screens/RoleEditScreen";

import TicketSearchScreen from "./screens/TicketSearchScreen";
import TicketNotifySearchScreen from "./screens/TicketNotifySearchScreen";
import TicketSearchScreenREVW from "./screens/TicketSearchScreenREVW";
import TicketSearchScreenSCOC from "./screens/TicketSearchScreenSCOC";
import TicketSearchScreenPCOC from "./screens/TicketSearchScreenPCOC";
import TicketSearchScreenFA from "./screens/TicketSearchScreenFA";
import TicketSearchScreenCOS from "./screens/TicketSearchScreenCOS";
import TicketSearchScreenINS from "./screens/TicketSearchScreenINS";
import TicketSearchScreenSAMP from "./screens/TicketSearchScreenSAMP";
import TicketSearchScreenSOF from "./screens/TicketSearchScreenSOF";
import TicketSearchScreenSOFF from "./screens/TicketSearchScreenSOFF";
import TicketSearchScreenSOFC from "./screens/TicketSearchScreenSOFC";
import TicketAddScreen from "./screens/TicketAddScreen";
import TicketEditScreen from "./screens/TicketEditScreen";
import TicketCalendar from "./screens/TicketCalendar";

import DocumentSearchScreen from "./screens/DocumentSearchScreen";

import PaymentSearchScreen from "./screens/PaymentSearchScreen";
import PaymentEditScreen from "./screens/PaymentEditScreen";

import CustomerSearchScreen from "./screens/CustomerSearchScreen";
import CustomerEditScreen from "./screens/CustomerEditScreen";

import VendorSearchScreen from "./screens/VendorSearchScreen";
import VendorEditScreen from "./screens/VendorEditScreen";

import GroupSearchScreen from "./screens/GroupSearchScreen";
import GroupEditScreen from "./screens/GroupEditScreen";

import ProductSearchScreen from "./screens/ProductSearchScreen";
import ProductEditScreen from "./screens/ProductEditScreen";

import LabReportSearchScreen from "./screens/LabReportSearchScreen";
import LabReportEditScreen  from "./screens/LabReportEditScreen";

import AuditSearchScreen  from "./screens/AuditSearchScreen";

import IsoDashboardScreen from "./screens/IsoDashboardScreen";
import IsoRequestAddScreen from "./screens/IsoRequestAddScreen";
import IsoRequestEditScreen from "./screens/IsoRequestEditScreen";
import IsoRequestSearchScreen from "./screens/IsoRequestSearchScreen";
import IsoRequestNotifySearchScreen from "./screens/IsoRequestNotifySearchScreen";
import IsoRequestCertificateView from "./screens/IsoRequestCertificateView";
import IsoCertificateEdit from "./screens/IsoCertificateEdit";

import AuditorSearchScreen from "./screens/AuditorSearchScreen";
import AuditorEditScreen from "./screens/AuditorEditScreen";

import TechnicalReviewerSearchScreen from "./screens/TechnicalReviewerSearchScreen";
import TechnicalReviewerEditScreen from "./screens/TechnicalReviewerEditScreen";

import InspectorSearchScreen from "./screens/InspectorSearchScreen";
import InspectorEditScreen from "./screens/InspectorEditScreen";

import IneDashboardScreen from "./screens/IneDashboardScreen";
import IneRequestAddScreen from "./screens/IneRequestAddScreen";
import IneRequestEditScreen from "./screens/IneRequestEditScreen";
import IneRequestSearchScreen from "./screens/IneRequestSearchScreen";
import IneTestingInspectorSearchScreen from "./screens/IneTestingInspectorSearchScreen";
import IneTestingInspectorEditScreen from "./screens/IneTestingInspectorEditScreen";
import IneTestingScopeSearchScreen from "./screens/IneTestingScopeSearchScreen";
import IneTestingScopeEditScreen from "./screens/IneTestingScopeEditScreen";
import IneCalendar from "./screens/IneCalendar";

import ClientDocumentRequestSearchScreen from "./screens/ClientDocumentRequestSearchScreen";
import ClientDocumentRequestEditScreen  from "./screens/ClientDocumentRequestEditScreen";

import IdiDashboardScreen from "./screens/IdiDashboardScreen";
import IdiInspectionDashboardScreen from "./screens/IdiInspectionDashboardScreen";
import IdiProjectSearchScreen  from "./screens/IdiProjectSearchScreen";
import IdiProjectAddScreen  from "./screens/IdiProjectAddScreen";
import IdiProjectEditScreen  from "./screens/IdiProjectEditScreen";
import IdiInspectionSearchScreen  from "./screens/IdiInspectionSearchScreen";
import IdiInspectionEditScreen  from "./screens/IdiInspectionEditScreen";
import IdiCustomerSearchScreen from "./screens/IdiCustomerSearchScreen";
import IdiCustomerEditScreen from "./screens/IdiCustomerEditScreen";
import IdiInspectorDetailSearchScreen from "./screens/IdiInspectorDetailSearchScreen";
import IdiInspectorDetailEditScreen from "./screens/IdiInspectorDetailEditScreen";
import IdiCalendar from "./screens/IdiCalendar";
import IdiImportScreen from "./screens/IdiImportScreen";

import { useDispatch, useSelector } from "react-redux";
import * as commonActions from "./actions/CommonActions";

const  App = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.login.user);
  const successMessage = useSelector((state) => state.common.successMessage);
  const errorMessage = useSelector((state) => state.common.errorMessage);

  React.useEffect(() => {
    if(successMessage) {
      toast.success(successMessage.toString(), {
        onClose: () => dispatch(commonActions.setSuccessMessage(""))
      });
    }
  }, [successMessage]);

  React.useEffect(() => {
    if(errorMessage) {
      toast.error(<div style={{whiteSpace:"pre-wrap"}}>{errorMessage.toString()}</div>, {
        onClose: () => dispatch(commonActions.setErrorMessage(""))
      });
    }
  }, [errorMessage]);

  if(user) {
    if(user.isCrmUser) {
      return(
        <Fragment>
          <Routes>
            <Route path="/" 
              element={
                <NonAuthLayout><NotAuthorized /></NonAuthLayout>
              }
            />
            <Route path="/logout"
              element={
                <NonAuthLayout><LogoutScreen /></NonAuthLayout>
              }
            />
          </Routes>
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={true}
            draggable={true}
            pauseOnHover={true}
            theme={"colored"}
            transition={Slide}
            style={{width:"30%"}}
          />
        </Fragment>
      );
    }

    if(user.isExternalUser) {
      return(
        <Fragment>
          <Routes>
            <Route path="/client-document-request-view/:linkId" 
              element={
                <NonAuthLayout><ClientDocumentRequestEditScreen /></NonAuthLayout>
              }
            />
            <Route path="/not-authorized" 
              element={
                <NonAuthLayout><NotAuthorized /></NonAuthLayout>
              }
            />
            <Route path="/logout"
              element={
                <NonAuthLayout><LogoutScreen /></NonAuthLayout>
              }
            />
          </Routes>
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={true}
            draggable={true}
            pauseOnHover={true}
            theme={"colored"}
            transition={Slide}
            style={{width:"30%"}}
          />
        </Fragment>
      );
    }

    return(
      <Fragment>
        <Routes>
          <Route exact path="/" 
            element={
              <VerticalLayout>{
                  user.defaultModule === "ISO" ? <IsoDashboardScreen />
                  : (user.defaultModule === "INE" ? <IneDashboardScreen /> 
                  : (user.defaultModule === "IDI" ? (user.canViewIdiProject ? <IdiDashboardScreen /> : (user.canViewIdiInspection ? <IdiInspectionDashboardScreen /> : <ClientDocumentRequestSearchScreen />)) : <KanbanScreen />))
              }</VerticalLayout>
            }
          />
          <Route exact path="/dashboard" 
            element={
              <VerticalLayout><DashboardScreen /></VerticalLayout>
            }
          />
          <Route path="/notifications" 
            element={
              <VerticalLayout><NotificationSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/emails" 
            element={
              <VerticalLayout><EmailSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/requests" 
            element={
              <VerticalLayout><TicketSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/request-notifications" 
            element={
              <VerticalLayout><TicketNotifySearchScreen /></VerticalLayout>
            }
          />
          <Route path="/revw-requests" 
            element={
              <VerticalLayout><TicketSearchScreenREVW /></VerticalLayout>
            }
          />
          <Route path="/scoc-requests" 
            element={
              <VerticalLayout><TicketSearchScreenSCOC /></VerticalLayout>
            }
          />
          <Route path="/pcoc-requests" 
            element={
              <VerticalLayout><TicketSearchScreenPCOC /></VerticalLayout>
            }
          />
          <Route path="/fa-requests" 
            element={
              <VerticalLayout><TicketSearchScreenFA /></VerticalLayout>
            }
          />
          <Route path="/cos-requests" 
            element={
              <VerticalLayout><TicketSearchScreenCOS /></VerticalLayout>
            }
          />
          <Route path="/ins-requests" 
            element={
              <VerticalLayout><TicketSearchScreenINS /></VerticalLayout>
            }
          />
          <Route path="/samp-requests" 
            element={
              <VerticalLayout><TicketSearchScreenSAMP /></VerticalLayout>
            }
          />
          <Route path="/processed-food-requests"
            element={
              <VerticalLayout><TicketSearchScreenSOF /></VerticalLayout>
            }
          />
          <Route path="/fresh-food-requests"
            element={
              <VerticalLayout><TicketSearchScreenSOFF /></VerticalLayout>
            }
          />
          <Route path="/chilled-food-requests"
            element={
              <VerticalLayout><TicketSearchScreenSOFC /></VerticalLayout>
            }
          />
          <Route path="/request-add" 
            element={
              <VerticalLayout><TicketAddScreen /></VerticalLayout>
            }
          />
          <Route path="/request-add/:id" 
            element={
              <VerticalLayout><TicketAddScreen /></VerticalLayout>
            }
          />
          <Route path="/request-edit/:id" 
            element={
              <VerticalLayout><TicketEditScreen /></VerticalLayout>
            }
          />
          <Route path="/request-calendar/:id?" 
            element={
              <VerticalLayout><TicketCalendar /></VerticalLayout>
            }
          />
          <Route path="/iso-requests" 
            element={
              <VerticalLayout><IsoRequestSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/iso-request-notifications" 
            element={
              <VerticalLayout><IsoRequestNotifySearchScreen /></VerticalLayout>
            }
          />
          <Route path="/iso-request-add" 
            element={
              <VerticalLayout><IsoRequestAddScreen /></VerticalLayout>
            }
          />
          <Route path="/iso-request-edit/:id" 
            element={
              <VerticalLayout><IsoRequestEditScreen /></VerticalLayout>
            }
          />
          <Route path="/iso-request-certificate/:id" 
            element={
              <VerticalLayout><IsoRequestCertificateView /></VerticalLayout>
            }
          />
          <Route path="/iso-certificate-edit/:id" 
            element={
              <VerticalLayout><IsoCertificateEdit /></VerticalLayout>
            }
          />
		      <Route path="/ine-requests" 
            element={
              <VerticalLayout><IneRequestSearchScreen /></VerticalLayout>
            }
          />
		      <Route path="/ine-request-add" 
            element={
              <VerticalLayout><IneRequestAddScreen /></VerticalLayout>
            }
          />
          <Route path="/ine-request-edit/:id" 
            element={
              <VerticalLayout><IneRequestEditScreen /></VerticalLayout>
            }
          />
          <Route path="/ine-inspectors" 
            element={
              <VerticalLayout><IneTestingInspectorSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/ine-inspector-edit/:id" 
            element={
              <VerticalLayout><IneTestingInspectorEditScreen /></VerticalLayout>
            }
          />
          <Route path="/ine-scopes" 
            element={
              <VerticalLayout><IneTestingScopeSearchScreen /></VerticalLayout>
            }
          />
		      <Route path="/ine-scope-add" 
            element={
              <VerticalLayout><IneTestingScopeEditScreen /></VerticalLayout>
            }
          />
          <Route path="/ine-scope-edit/:id" 
            element={
              <VerticalLayout><IneTestingScopeEditScreen /></VerticalLayout>
            }
          />
          <Route path="/ine-calendar" 
            element={
              <VerticalLayout><IneCalendar /></VerticalLayout>
            }
          />
          <Route path="/auditors" 
            element={
              <VerticalLayout><AuditorSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/auditor-edit/:id" 
            element={
              <VerticalLayout><AuditorEditScreen /></VerticalLayout>
            }
          />
          <Route path="/technical-reviewers" 
            element={
              <VerticalLayout><TechnicalReviewerSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/technical-reviewer-edit/:id" 
            element={
              <VerticalLayout><TechnicalReviewerEditScreen /></VerticalLayout>
            }
          />
          <Route path="/inspectors" 
            element={
              <VerticalLayout><InspectorSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/inspector-edit/:id" 
            element={
              <VerticalLayout><InspectorEditScreen /></VerticalLayout>
            }
          />
          <Route path="/documents" 
            element={
              <VerticalLayout><DocumentSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/payments" 
            element={
              <VerticalLayout><PaymentSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/payment-edit/:id" 
            element={
              <VerticalLayout><PaymentEditScreen /></VerticalLayout>
            }
          />
          <Route path="/users" 
            element={
              <VerticalLayout><UserSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/user-edit/:id" 
            element={
              <VerticalLayout><UserEditScreen /></VerticalLayout>
            }
          />
          <Route path="/user-add" 
            element={
              <VerticalLayout><UserEditScreen /></VerticalLayout>
            }
          />
          <Route path="/profile" 
            element={
              <VerticalLayout><UserProfileScreen /></VerticalLayout>
            }
          />
          <Route path="/companies" 
            element={
              <VerticalLayout><CompanySearchScreen /></VerticalLayout>
            }
          />
          <Route path="/company-edit/:id" 
            element={
              <VerticalLayout><CompanyEditScreen /></VerticalLayout>
            }
          />
          <Route path="/company-add" 
            element={
              <VerticalLayout><CompanyEditScreen /></VerticalLayout>
            }
          />
          <Route path="/roles" 
            element={
              <VerticalLayout><RoleSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/role-edit/:id" 
            element={
              <VerticalLayout><RoleEditScreen /></VerticalLayout>
            }
          />
          <Route path="/customers" 
            element={
              <VerticalLayout><CustomerSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/customer-edit/:id" 
            element={
              <VerticalLayout><CustomerEditScreen /></VerticalLayout>
            }
          />
          <Route path="/customer-add" 
            element={
              <VerticalLayout><CustomerEditScreen /></VerticalLayout>
            }
          />
          <Route path="/vendor-search/:type" 
            element={
              <VerticalLayout><VendorSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/vendor-edit/:id" 
            element={
              <VerticalLayout><VendorEditScreen /></VerticalLayout>
            }
          />
          <Route path="/vendor-add/:type" 
            element={
              <VerticalLayout><VendorEditScreen /></VerticalLayout>
            }
          />
          <Route path="/groups" 
            element={
              <VerticalLayout><GroupSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/group-edit/:id" 
            element={
              <VerticalLayout><GroupEditScreen /></VerticalLayout>
            }
          />
          <Route path="/group-add" 
            element={
              <VerticalLayout><GroupEditScreen /></VerticalLayout>
            }
          />
          <Route path="/products" 
            element={
              <VerticalLayout><ProductSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/product-edit/:id" 
            element={
              <VerticalLayout><ProductEditScreen /></VerticalLayout>
            }
          />
          <Route path="/product-add" 
            element={
              <VerticalLayout><ProductEditScreen /></VerticalLayout>
            }
          />
          <Route path="/lab-reports" 
            element={
              <VerticalLayout><LabReportSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/lab-report-add" 
            element={
              <VerticalLayout><LabReportEditScreen /></VerticalLayout>
            }
          />
          <Route path="/lab-report-edit/:id" 
            element={
              <VerticalLayout><LabReportEditScreen /></VerticalLayout>
            }
          />
          <Route path="/client-document-requests" 
            element={
              <VerticalLayout><ClientDocumentRequestSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/client-document-request-add" 
            element={
              <VerticalLayout><ClientDocumentRequestEditScreen /></VerticalLayout>
            }
          />
          <Route path="/client-document-request-edit/:id" 
            element={
              <VerticalLayout><ClientDocumentRequestEditScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-projects" 
            element={
              <VerticalLayout><IdiProjectSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-project-add" 
            element={
              <VerticalLayout><IdiProjectAddScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-project-edit/:id" 
            element={
              <VerticalLayout><IdiProjectEditScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-inspection-dashboard" 
            element={
              <VerticalLayout><IdiInspectionDashboardScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-inspections" 
            element={
              <VerticalLayout><IdiInspectionSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-inspection-edit/:id" 
            element={
              <VerticalLayout><IdiInspectionEditScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-customers/:type" 
            element={
              <VerticalLayout><IdiCustomerSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-customer-edit/:id" 
            element={
              <VerticalLayout><IdiCustomerEditScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-customer-add/:type" 
            element={
              <VerticalLayout><IdiCustomerEditScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-inspectors" 
            element={
              <VerticalLayout><IdiInspectorDetailSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-inspector-edit/:id" 
            element={
              <VerticalLayout><IdiInspectorDetailEditScreen /></VerticalLayout>
            }
          />
          <Route path="/idi-calendar/:id?" 
            element={
              <VerticalLayout><IdiCalendar /></VerticalLayout>
            }
          />
          <Route path="/idi-import" 
            element={
              <VerticalLayout><IdiImportScreen /></VerticalLayout>
            }
          />
          <Route path="/audits" 
            element={
              <VerticalLayout><AuditSearchScreen /></VerticalLayout>
            }
          />
          <Route path="/not-authorized" 
            element={
              <VerticalLayout><NotAuthorized /></VerticalLayout>
            }
          />
          <Route path="/invalid-company" 
            element={
              <VerticalLayout><InvalidCompany /></VerticalLayout>
            }
          />
          <Route path="/invalid-company/:type/:companyId/:moduleName/:id" 
            element={
              <VerticalLayout><InvalidCompany /></VerticalLayout>
            }
          />
          <Route path="/otp" 
            element={
              <VerticalLayout><UserProfileOtpView /></VerticalLayout>
            }
          />
          <Route path="/logout" 
            element={
              <NonAuthLayout><LogoutScreen /></NonAuthLayout>
            }
          />
          <Route path="/not-found"
            element={
              <VerticalLayout><NotFoundScreen /></VerticalLayout>
            }
          />
          <Route path="*" element={<Navigate to ="/not-found" />}/>
        </Routes>
              
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss={true}
          draggable={true}
          pauseOnHover={true}
          theme={"colored"}
          transition={Slide}
          style={{width:"30%"}}
        />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Routes>
        <Route exact path="/" 
          element={
            <NonAuthLayout><LoginScreen /></NonAuthLayout>
          }
        />
        <Route exact path="/forgot-password" 
          element={
            <NonAuthLayout><PasswordForgotScreen /></NonAuthLayout>
          }
        />
        <Route path="/reset-password/:id" 
          element={
            <NonAuthLayout><PasswordResetScreen /></NonAuthLayout>
          }
        />
        <Route path="/iso-request-certificate/:id" 
          element={
            <NonAuthLayout><IsoRequestCertificateView /></NonAuthLayout>
          }
        />
        <Route path="/client-document-request-view/:linkId" 
          element={
            <NonAuthLayout><ClientDocumentRequestEditScreen /></NonAuthLayout>
          }
        />
        <Route path="/otp" 
          element={
            <NonAuthLayout><UserProfileOtpView /></NonAuthLayout>
          }
        />
        <Route path="/logout" 
          element={
            <NonAuthLayout><LogoutScreen /></NonAuthLayout>
          }
        />
      </Routes>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={true}
        draggable={true}
        pauseOnHover={true}
        theme={"colored"}
        transition={Slide}
        style={{width:"30%"}}
      />
    </Fragment>
  );
}

export default App;
